import { Box, IconButton, Tooltip } from "@mui/material";
import React, { FC, JSX, useEffect, useState } from "react";
import {
  DataType,
  PagingPosition,
  SortDirection,
  SortingMode,
  EditingMode,
  Table,
  useTable,
  useTableInstance,
  ITableInstance,
  ActionType,
} from "ka-table";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  KATableActionBttnsTypes,
  KATableHeaderTypes,
} from "./SweetTable.interface";
import { ICellTextProps } from "ka-table/props";

import { orderBy } from "lodash";
import moment from "moment";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";

import CellEditorBoolean from "ka-table/Components/CellEditorBoolean/CellEditorBoolean";
import useResponsive from "../../hooks/useResponsive";

// import "./custome-theme.scss";

// import { useLanguage } from "../../context/LanguageContext";
type MainTableProps = {
  tableColumns: Array<KATableHeaderTypes>;
  tableData: Array<any>;
  searchText?: string;
  rowKeyField?: string;
  cellActionBtns?: Array<KATableActionBttnsTypes>;
  table: ITableInstance;
  tableTitle?: string;
  pageIndex?: number;
  APILoading?: boolean;
  pageSize?: number;
  isSSR?: boolean;
  pageCount?: number;
  customeComponent?: any;
  rowColors?: Array<{ index: number; color: string }>;
  searchTitle?: string;
  isPaging?: any;
  CustomePageSizes?: number[];
  isPageSizeGiven?: boolean;
  filtersAllow?: boolean;
  ColumnSettings?: boolean;
};
const MainTable: FC<MainTableProps> = ({
  rowKeyField = "row_key_field",
  tableColumns,
  tableData,
  searchText,
  cellActionBtns,
  table,
  tableTitle,
  pageIndex,
  APILoading,
  pageSize,
  isSSR,
  pageCount,
  customeComponent,
  rowColors,
  searchTitle,
  isPaging = true,
  CustomePageSizes,
  isPageSizeGiven = false,
  filtersAllow = true,
  ColumnSettings = false,
}): JSX.Element => {
  const ActionButtons = (props: any) => {
    return (
      <Box
        display="flex"
        flexDirection={"row"}
        flexWrap={"wrap"}
        alignItems={"center"}
      >
        {cellActionBtns?.map(({ BtnIcon, ...rest }, index) => {
          return (
            <Tooltip title={rest.title}>
              <IconButton>
                <BtnIcon
                  key={index}
                  onClick={() => rest.btnAction(props.rowData)}
                  sx={{ color: rest.btnColor ?? "#707070" }}
                />
              </IconButton>
            </Tooltip>
          );
        })}
      </Box>
    );
  };
  const [tableDataSet, setTableDataSet] = useState<Array<any>>([]);
  useEffect(() => {
    if ( Array.isArray(tableData)  && tableData.length)
      setTableDataSet(tableData.map((self, index) => ({ ...self, index })));
    else setTableDataSet([]);
  }, [tableData]);

  //********************for laptop screen*************************** */
  const { isBelowLargeScreen } = useResponsive();

  // const { getLng } = useLanguage()

  const ColumnSettingsContorl = ({
    columns,
    onChange,
  }: {
    columns: Array<KATableHeaderTypes>;
    onChange: (columnKey: string, visible: boolean) => void;
  }) => {
    const [columnVisibility, setColumnVisibility] = useState(
      columns.map((column) => ({
        ...column,
        visible: column.visible !== false,
      }))
    );

    const handleCheckboxChange = (key: string) => {
      setColumnVisibility((prevColumns) =>
        prevColumns.map((column) =>
          column.key === key ? { ...column, visible: !column.visible } : column
        )
      );

      const updatedColumn = columnVisibility.find((col) => col.key === key);
      if (updatedColumn) {
        onChange(key, !updatedColumn.visible);
      }
    };

    return (
      <div className="p-4 border border-gray-300 rounded-md mb-2">
        {/* <div>
          <MultiSelect options={columnVisibility} onValueChange={function (value: string[]): void {
            throw new Error("Function not implemented.");
          } }/>
        </div> */}
        {/* <div className="flex flex-wrap gap-x-6 gap-y-2">
          {columnVisibility.map((column) => (
            <label
              key={column.key}
              className="flex items-center space-x-2 whitespace-nowrap"
            >
              <input
                type="checkbox"
                className="form-checkbox h-4 w-4 text-blue-600"
                checked={column.visible}
                onChange={() => handleCheckboxChange(column.key)}
              />
              <span className="text-sm text-gray-700">{column.title}</span>
            </label>
          ))}
        </div> */}
      </div>
    );
  };

  return (
    <Box sx={{ overflowX: "auto" }}>
      {/* {ColumnSettings && (
        <ColumnSettingsContorl
          columns={tableColumns}
          onChange={(columnKey, visible) => {
            visible ? table.showColumn(columnKey) : table.hideColumn(columnKey);
          }}
        />
      )} */}
      <Table
       noData={{
        text: 'No Data Found'
    }}
        table={table}
        columns={tableColumns}
        data={tableDataSet}
        searchText={!!isSSR ? "" : searchText}
        loading={{
          enabled: APILoading,
        }}
        childComponents={{
          tableWrapper: {
            elementAttributes: () => ({
              style: {
                maxHeight: isBelowLargeScreen ? "45vh" : "60vh",
                overflowX: "auto",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              },
            }),
          },
          dataRow: {
            elementAttributes: ({ rowData, index }: any) => {
              let rowColor = rowColors?.find(
                (colorConfig) => colorConfig.index === rowData.index
              )?.color;

              const backgroundColor = rowColor
                ? rowColor
                : Number(rowData?.index) % 2 !== 0
                ? "#f9fafb"
                : "#fff";

              return {
                style: {
                  backgroundColor,
                  padding: "0px",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                },
                title:
                  rowData.name && rowData.score
                    ? `${rowData.name}: ${rowData.score}`
                    : "",
              };
            },
          },
          cell: {
            elementAttributes: (props: any) => {
              
              const HeadertextAlign = props?.column?.HeadertextAlign;
              return {
                ...props,
                style: {
                  ...props.column.style,
                  border: "1px solid #e0e0e0",
                  textAlign: HeadertextAlign ? HeadertextAlign : "center",
                  verticalAlign: "middle",
                  color: "#333",
                },
              };
            },
          },
          headCell: {
            elementAttributes: (props: any) => {
              const BodytextAlign = props?.column?.BodytextAlign;
              return {
                ...props,
                style: {
                  backgroundColor: 'rgba(9,71,128,255)',
                  color: '#FFFFFF',
                  textAlign: BodytextAlign ? BodytextAlign : 'center',
                  zIndex: 49,
                },
              };
            },
          },
          sortIcon: {
            content: ({ column }) => {
              return column.sortDirection === SortDirection.Ascend ? (
                <ArrowUpwardIcon
                  style={{
                    color: "#FFFFFF",
                    fontSize: 15,
                    marginBottom: "4px",
                  }}
                />
              ) : (
                <ArrowDownwardIcon
                  style={{
                    color: "#FFFFFF",
                    fontSize: 15,
                    marginBottom: "4px",
                  }}
                />
              );
            },
          },
          cellText: {
            content: (props: any) => {
              switch (props.column.key) {
                case "action":
                  return <ActionButtons {...props} />;
              }
              switch (props.column.dataType) {
                case DataType.Date:
                  return props.value
                    ? moment(String(props.value).split("T")[0]).format(
                        "DD-MM-YYYY"
                      )
                    : "N/A";
                case "Currency":
                  return !!props.value
                    ? (+(props.value || 0))?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency: "INR",
                      })
                    : 0;
                case "Conditional":
                  return props.value === true ? (
                    <Tooltip title={"File Exist"}>
                      <CheckCircleOutlineIcon
                        sx={{
                          color: "#008000",
                          fontSize: 18,
                          ml: 5,
                          mr: 5,
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title={"File Not Exist"}>
                      <DoNotDisturbAltIcon
                        sx={{
                          color: "#FF0000",
                          fontSize: 18,
                          ml: 5,
                          mr: 5,
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  );
                case "custome":
                  return customeComponent(props);
              }
            },
          },
          pagingIndex: {
            elementAttributes: ({ isActive }) => ({
              className: `page-item ${isActive ? "active" : ""}`,
            }),
            content: ({ text, isActive }) => (
              <div className={`page-link ${isActive ? "active" : ""}`}>
                {text}
              </div>
            ),
          },
          pagingPages: {
            elementAttributes: () => ({
              className: "pagination",
            }),
          },
          pagingSize: {
            elementAttributes: () => ({
              className: "paginationSize",
            }),
          },
        }}
        paging={
          isPaging
            ? {
                enabled: true,
                pageIndex: pageIndex ?? 0,
                pageSize: pageSize ?? 10,
                pageSizes: isPageSizeGiven
                  ? CustomePageSizes
                  : [2, 5, 10, 50, 100],
                pagesCount: isSSR ? pageCount ?? 0 : 0,
                position: PagingPosition.Bottom,
              }
            : undefined
        }
        columnResizing={true}
        extendedSort={(data, columns) => {
          let sortedColumns = columns?.filter((c) => c.sortDirection);
          if (sortedColumns.length === 0) {
            return data;
          }
          sortedColumns = orderBy(sortedColumns, ["sortIndex"], ["asc"]);
          const iteratee = sortedColumns.map((c) => c.key);
          const order = sortedColumns.map((c) =>
            c.sortDirection === SortDirection.Ascend ? "asc" : "desc"
          );
          return orderBy(data, iteratee, order);
        }}
        rowKeyField={"id"}
        sortingMode={SortingMode.MultipleTripleStateRemote}
      />
    </Box>
  );
};

export default MainTable;
